import React from 'react'
import { Link } from 'react-router-dom'
import { Button, ChevronRightIcon, DiversityIcon, InclusionIcon, Tooltip } from '@diversioteam/diversio-ds'

import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'
import { BreadcrumbLink } from 'context/breadcrumbs/breadcrumbsContext/BreadcrumbContext.types'

import * as S from './analyzeLinks.styles'

export const AnalyzeLinks = ({ paths }: { paths: BreadcrumbLink[] }) => {
    return (
        <S.Container>
            <S.Links>
                <Tooltip title="Diversity" size="medium">
                    <Button
                        component={Link}
                        to={generateCompanyURI('/analyze2/diversity')}
                        size="small"
                        color="primaryLight"
                        iconOnly
                    >
                        <DiversityIcon width={16} height={16} />
                    </Button>
                </Tooltip>

                <Tooltip title="Inclusion" size="medium">
                    <Button
                        component={Link}
                        to={generateCompanyURI('/analyze2/inclusion')}
                        size="small"
                        color="primaryLight"
                        iconOnly
                    >
                        <InclusionIcon width={16} height={16} />
                    </Button>
                </Tooltip>
            </S.Links>

            {paths && (
                <S.Breadcrumbs
                    separator={<ChevronRightIcon type="line" height={8.75} color="#AEABB8" />}
                    aria-label="breadcrumb"
                >
                    <Link to={generateCompanyURI('/analyze2')}>Analyze</Link>

                    {paths.map((path, id) => {
                        return (
                            <Link to={path.to} color="textPrimary" key={id}>
                                {path.label}
                            </Link>
                        )
                    })}
                </S.Breadcrumbs>
            )}
        </S.Container>
    )
}
